module.exports = __webpack_public_path__ + "img/s00170.686dc084.png";